const AdvantagesMenu = {
    menu: [
        {
            title: 'CONVENIENT_FILTERING',
            text: 'CONVENIENT_FILTERING_TEXT'
        },
        {
            title: 'NOTIFICATIONS_ONLNE',
            text: 'NOTIFICATIONS_ONLNE_TEXT'
        },
        {
            title: 'EXTENDED_ANALYTIC',
            text: 'ANALYTIC_TEXT'
        },
        {
            title: 'STRUCTURED_SELECTION',
            text: 'STRUCTURED_SELECTION_TEXT'
        },
        {
            title: 'EXPORT_PUBLICATIONS',
            text: 'EXPORT_PUBLICATIONS_TEXT'
        },
        {
            title: 'USERS_NUMBER',
            text: 'USERS_NUMBER_TEXT'
        },
        {
            title: 'INTERCATIVE_DASHBOARDS',
            text: 'INTERCATIVE_DASHBOARDS_TEXT'
        },
        {
            title: 'SAVING_FILTERS',
            text: 'SAVING_FILTERS_TEXT'
        }
    ]
}

export default AdvantagesMenu;